import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/Spotify_Logo_RGB_White.png'


_pushScopeId("data-v-194fe630")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "shelf-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Spotify"
  })
], -1)
const _hoisted_2 = { class: "shelf" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlaylistCard = _resolveComponent("PlaylistCard")!

  return (_openBlock(), _createElementBlock("section", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playlists, (playlist, index) => {
        return (_openBlock(), _createBlock(_component_PlaylistCard, {
          key: index,
          source: playlist,
          onClick: ($event: any) => (_ctx.selectIndex(index))
        }, null, 8, ["source", "onClick"]))
      }), 128))
    ])
  ]))
}